module.exports = __webpack_public_path__ + "static/media/penguin-igloo.6eaaa91b.png";